

export const sendSidebarEvent = (open: boolean|null) => document.dispatchEvent(new CustomEvent('sidebar:toggle', { detail: { value: open } }));
export const addSidebarEventListener = (callback: (e: CustomEvent<{ value: boolean|null }>)=>void ) => document.addEventListener('sidebar:toggle', callback)
export const removeSidebarEventListener = (callback: (e: CustomEvent<{ value: boolean|null }>)=>void ) => document.removeEventListener('sidebar:toggle', callback)
